var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-submit",class:{'loading': _vm.loading},attrs:{"disabled":_vm.disabled && !_vm.loading},on:{"click":_vm.apply}},[(_vm.loading)?_c('span',{staticClass:"spinner-border-custom",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }